<template>
  <drawer @close="close()" width="680">
    <v-container class="px-5 px-md-18 py-14 py-md-8 pa-md-20">
      <v-card-title
        class="display-1 font-weight-bold pa-0 mb-8 letter-spacing-normal"
      >
        Summary
        <v-progress-linear v-if="groupModel.fetching" indeterminate />
      </v-card-title>
      <v-card-text class="pa-0">
        <v-row
          v-for="(summary, index) in report"
          :key="index"
          class="justify-lg-space-between align-center"
        >
          <v-col sm="12">
            <v-row
              class="justify-space-between align-center mb-10 mb-mb-0"
              v-if="group.name"
            >
              <v-col class="pa-0">
                <v-card-title
                  class="py-0 title font-weight-bold letter-spacing-normal"
                >
                  {{ getSummaryTitle(group.name) }}
                </v-card-title>
              </v-col>
            </v-row>
            <v-row class="justify-lg-space-between align-center">
              <v-col class="pa-0">
                <v-skeleton-loader
                  v-if="!groupModel.fetched || groupModel.fetching"
                  height="180"
                  type="table-thead, table-tbody, table-tfoot"
                  class="mb-12"
                />
                <v-data-table
                  v-else
                  :headers="headers"
                  :items="summary.sightings"
                  v-bind="
                    summary.sightings.length > 5
                      ? { itemsPerPage: 5 }
                      : { hideDefaultFooter: true }
                  "
                  class="primary-table secondary-table border-radius-0 v-data-table-1 v-data-table-1--style3"
                />
              </v-col>
            </v-row>
            <div
              class="font-weight-bold letter-spacing-normal ma-0 d-flex  white black--text text-right justify-center pa-2 v-card--link"
            >
              {{ 'Total Contributed Amount ' + ' $' + group.amount }}
            </div>
          </v-col>
        </v-row>
      </v-card-text>
      <div>
        <v-card-title class="display-1 font-weight-bold pa-0 mb-8">
          Locations
        </v-card-title>
        <v-list-item :inactive="true" :ripple="false" color="#2f2727">
          <v-list-item-icon>
            <v-icon color="black">$marker</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="font-weight-bold">
              {{ getLocationString(group.location) }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <div class="map-container position-relative">
          <div class="map-card rounded-map" style="height:300px">
            <MapBox
              :show-zoom="true"
              :zoom="8"
              :mark-center="true"
              :center="{
                ...group.location,
                name: group.name,
              }"
            />
          </div>
        </div>
      </div>
    </v-container>
    <template v-slot:append>
      <div class="px-5 px-md-20 py-12">
        <v-btn block large class="primary" @click="close()">
          Done
        </v-btn>
      </div>
    </template>
  </drawer>
</template>

<script>
import Group from '@models/CustomGroup';

export default {
  name: 'Summary',
  components: {
    Drawer: () => import('@layouts/_partials/Drawer'),
    MapBox: () => import('@components/utilities/MapBox'),
  },
  props: {
    group: {
      type: Object,
      required: true,
      validator(data) {
        if (!data.id) {
          throw new Error('Invalid group object provided!');
        }
        return true;
      },
    },
  },
  data() {
    return {
      headers: [
        {
          text: 'Species',
          align: 'left',
          sortable: false,
          value: 'species.name',
        },
        { text: 'Count', value: 'count', width: 200 },
      ],
      groupModel: new Group(),
      sightings: [],
      trips: [],
    };
  },
  computed: {
    report() {
      return [{ sightings: this.sightings }];
    },
  },
  methods: {
    async fetchSightings() {
      let response = await this.groupModel.fetchSightings(this.group.id);
      if (response) {
        this.sightings = response.data;
      }
    },
    getSummaryTitle(member) {
      let name = member;
      if (name.endsWith('s')) {
        return `${name}' Sightings`;
      }
      return `${name}'s Sightings`;
    },
    close() {
      this.$emit('exit');
    },
  },
  mounted() {
    this.fetchSightings();
  },
};
</script>
